import AscTextInput, { AscTextInputProps } from "../AscTextInput/AscTextInput";
import styles from "./AscPasswordInput.module.scss";
import { useRef, useState } from "react";
import { EyeClosedIcon, EyeIcon } from "../../AscIcons";
import classNames from "classnames";

export interface AscPasswordInputProps
  extends Omit<AscTextInputProps, "type" | "ref"> {
  ref?: React.Ref<HTMLInputElement>;
}

export default function AscPasswordInput({
  className,
  ...props
}: AscPasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  function toggleShowPassword() {
    if (!props?.disabled) {
      setShowPassword((showPassword) => !showPassword);
    }
  }
  return (
    <AscTextInput
      className={classNames(styles.ground, className)}
      innerInputClassName={styles.innerInputClassName}
      suffixComponent={
        <span
          className={styles.iconWrapper}
          onClick={toggleShowPassword}
          data-testid="asc-password-input-toggle"
        >
          {showPassword ? (
            <EyeClosedIcon className={styles.icon} />
          ) : (
            <EyeIcon className={styles.icon} />
          )}
        </span>
      }
      type={showPassword ? "text" : "password"}
      {...props}
      ref={inputRef}
    />
  );
}
